module.exports = __webpack_public_path__ + "static/media/sopt24kz.30637707.pdf";